define([
	"dojo/_base/array",
	"./TextToolbarSelect",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(array,TextToolbarSelect,_Plugin,PluginFactory,util) {

	var OPTIONS = ['8', '10' ,'12', '14', '16', '18', '20', '22', '24', '26', '32','36', '42', '48', '54', '58', '64'];

	return PluginFactory.declare([TextToolbarSelect, _Plugin], {
		bText: true,
		"class": "svgSelect csi-text-formatting-select-button",
		cssStyle: "font-size",
		pluginName: "fontSize",
		title: "CanvasFontSize",
		fontSize: 12,

		/**
		 * Populate font-size store with values based on SVG height
		 */
		postMixInProperties: function() {
			this.options = array.map(OPTIONS, function(size) {
				return {label: size + "px", value: size + "px"};
			});
			this.inherited(arguments);
		},

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			let value;
			if (shapes && shapes.length && this.editor.isSelectCanvasMode()) {
				value = this.editor.canvasApp.selection.getCommonTextValue(shapes, this.cssStyle, true);
			} else {
				value = textAttrs[this.cssStyle] || this.fontSize+"px";
			}

			this.set("value", value, false); 
			return this.inherited(arguments);
		},

		/**
		 * Apply style
		 * @param  {Object} value
		 */
		onChange: function(value) {
			this.editor.setTextStyle(this.cssStyle, value, true);
		}
	});
});
